const ASSETS = [
  "401k",
  "403(b)",
  "529 Plan",
  "Beneficiary",
  "Brokerage",
  "Cash",
  "Corporate Account",
  "Coverdell ESA",
  "Custodial Account",
  "Defined Benefit",
  "Defined Contribution",
  "ESOP",
  "Fixed Annuity",
  "Individual",
  "Individual 401k",
  "Joint Account",
  "Other",
  "Partnership",
  "Profit Sharing Plan",
  "Rollover IRA",
  "Roth 401k",
  "Roth IRA",
  "Sep IRA",
  "Simple IRA",
  "Sole Proprietorship Account",
  "Tenants by Entirety",
  "Tenants in Common",
  "Traditional IRA",
  "Trust",
  "Variable Annuity",
];

const TaxFilingStatuses = {
  SINGLE: {
    label: "Single",
    itemizedDeduction: 12551,
    elderlyOrDisabled: 5000,
  },
  MARRIED_FILING_JOINTLY: {
    label: "Married Filing Jointly",
    itemizedDeduction: 12551,
    elderlyOrDisabled: 5000,
  },
  MARRIED_FILING_SEPARATELY: {
    label: "Married Filing Separately",
    itemizedDeduction: 18801,
    elderlyOrDisabled: 3750,
  },
  HEAD_OF_HOUSEHOLD: {
    label: "Head of Household",
    itemizedDeduction: 12101,
    elderlyOrDisabled: 5000,
  },
};

const TaxDeductionPreferences = {
  STANDARD: "Standard",
  ITEMIZED: "Itemized",
};

const States = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FM: "Federated States of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export { ASSETS, TaxFilingStatuses, TaxDeductionPreferences, States };
